"use client";

import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { Lead } from "../table-data/schema";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";
import moment from "moment";

// Define the columns for the leads table
export const columns: ColumnDef<Lead>[] = [
  // Actions column
  {
    id: "actions",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Actions" />
    ),
    cell: ({ row }) => <DataTableRowActions row={row} />,
    enableSorting: false,
    enableHiding: false,
  },

  // Created At column
  {
    accessorKey: "createdAt",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: ({ row }) => (
      <div className="w-[80px]">
        {moment(row.getValue("createdAt")).format("MM-DD-YY")}
      </div>
    ),
    enableSorting: false,
    enableHiding: false,
  },

  // First Name column (concatenates with last name if first name is missing)
// First Name column (concatenates with last name)
{
  accessorKey: "firstName",
  header: ({ column }) => (
    <DataTableColumnHeader column={column} title="Full Name" />
  ),
  cell: ({ row }) => {
    const firstName = row.getValue("firstName") || "";
    const lastName = row.original.lastName || "";
    return (
      <div>
        {`${firstName} ${lastName}`.trim()}
      </div>
    );
  },
  enableSorting: true,
  enableHiding: true,
},


  

  // Email column
  {
    accessorKey: "email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="E-mail" />
    ),
    cell: ({ row }) => <div className="w-[190px]">{row.getValue("email")}</div>,
    enableSorting: true,
    enableHiding: true,
  },

  // Profile Progress column
  {
    accessorKey: "formProgress",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Profile Progress" />
    ),
    cell: ({ row }) => <div>{row.getValue("formProgress")}</div>,
    enableSorting: true,
    enableHiding: true,
  },

  // Investment Amount column with currency formatting
  {
    accessorKey: "investmentAmount",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Amount" />
    ),
    cell: ({ row }) => {
      const amount = row.getValue("investmentAmount");
      let formattedAmount = "";

      if (typeof amount === "number" && !isNaN(amount)) {
        formattedAmount = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(amount);
      }

      return <div>{formattedAmount}</div>;
    },
    enableSorting: true,
    enableHiding: true,
  },
];
